// AddFAQPage.js
import React from 'react';
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { addFAQ } from '../../services/Admin/adminServices'; // your API service
import toast from 'react-hot-toast';

const AddFAQPage = () => {
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    question: Yup.string().required('Question is required'),
    answer: Yup.string().required('Answer is required'),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      await addFAQ(values);
      toast.success('FAQ added successfully!');
      resetForm();
      navigate('/faqs');  
    } catch (error) {
      console.error('Error adding FAQ:', error);
      toast.error('Failed to add FAQ');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="  ">
      <h2 >Add New FAQssss</h2>
      <Formik
        initialValues={{ question: '', answer: '' }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <FormikForm>
            <div className="mb-3">
              <label htmlFor="question" className="form-label">Question</label>
              <Field
                name="question"
                id="question"
                className="form-control"
                   style={{ borderColor: '#0AB7EA',  }} 
              />
              <div className="text-danger">
                <ErrorMessage name="question" />
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="answer" className="form-label">Answer</label>
              <Field
                as="textarea"
                name="answer"
                id="answer"
                className="form-control"
                rows={4}
                style={{ borderColor: '#0AB7EA',  }} 
              />
              <div className="text-danger">
                <ErrorMessage name="answer" />
              </div>
            </div>

            <button type="submit" className="btn " style={{background:"#0AB7EA", color:"white"}} disabled={isSubmitting}>
              {isSubmitting ? 'Saving...' : 'Add FAQ'}
            </button>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};

export default AddFAQPage;
